const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e3a47;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Light-S"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.16,69.87a2.43,2.43,0,0,0,1.9-.93L71.29,56.15a2.55,2.55,0,0,0,.78-1.81A2.34,2.34,0,0,0,69.63,52a2.46,2.46,0,0,0-1.85.78l-6.15,6.5-3,3.12.19-5.66V25.05a2.66,2.66,0,0,0-5.32,0V56.74l.2,5.66-3-3.12-6.15-6.5A2.54,2.54,0,0,0,42.63,52a2.31,2.31,0,0,0-2.44,2.34A2.55,2.55,0,0,0,41,56.15L54.2,68.94A2.47,2.47,0,0,0,56.16,69.87ZM22.81,106.79H89.46c7.71,0,11.62-3.86,11.62-11.48V73c0-3.22-.44-4.78-2-6.73L85.26,49.07c-4.2-5.18-6.79-8-13.23-8H66.61v4.79h5.85c2.89,0,5.62,2.19,7.52,4.59L94.1,68.31c1.36,1.76.92,2.49-1,2.49H68a2.56,2.56,0,0,0-2.64,2.83v.15a9.23,9.23,0,1,1-18.45,0v-.15a2.6,2.6,0,0,0-2.69-2.83h-25c-2,0-2.34-.83-1-2.49L32.28,50.44c1.9-2.4,4.64-4.59,7.52-4.59h5.91V41.06H40.24c-6.45,0-9,2.83-13.23,8L13.19,66.31c-1.56,2-2,3.51-2,6.73V95.31C11.19,102.93,15.09,106.79,22.81,106.79Zm.09-5.42c-4,0-6.29-2.15-6.29-6.35V75.73H41.75c.78,7.28,6.74,12.5,14.41,12.5S69.73,83,70.51,75.73H95.66V95c0,4.2-2.3,6.35-6.3,6.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.6ddfc55d1cf8ee6e79d7b353633582d5.svg";
export { ForwardRef as ReactComponent };